(function () {
  'use strict';

  function euro(amountCents) {
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(amountCents / 100);
  }
  function normalize(s) {
    return (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }
  function qs(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  /* Tramos por peso: deben coincidir con el perfil de envío de Shopify (zona Península). */
  var ENVIO_TRAMOS = [{ maxGramos: 1990, cents: 595 }, { maxGramos: 6990, cents: 695 }, { maxGramos: Infinity, cents: 895 }];
  var ENVIO_DESDE_CENTS = ENVIO_TRAMOS[0].cents;
  /* El 10 % va por código (CARTUCHOYA10), se introduce en el paso de pago: el carrito no lo puede calcular. */
  var DTO_DESDE_CENTS = 5000;
  function shippingFor(subtotalCents, gramos) {
    for (var i = 0; i < ENVIO_TRAMOS.length; i++) {
      if ((gramos || 0) <= ENVIO_TRAMOS[i].maxGramos) return ENVIO_TRAMOS[i].cents;
    }
    return ENVIO_TRAMOS[ENVIO_TRAMOS.length - 1].cents;
  }

  /* ---------- Countdown (cosmético, 10 min, arranca en cada carga) ---------- */
  function startCountdowns() {
    var total = 600;
    var els = document.querySelectorAll('[data-countdown]');
    if (!els.length) return;
    function tick() {
      total = Math.max(0, total - 1);
      var m = String(Math.floor(total / 60)).padStart(2, '0');
      var s = String(total % 60).padStart(2, '0');
      els.forEach(function (el) {
        el.textContent = (el.getAttribute('data-label') || 'Tu carrito está reservado por') + ' ' + m + ':' + s;
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function renderDrawer(cart) {
    var empty = document.getElementById('cart-drawer-empty');
    var full = document.getElementById('cart-drawer-full');
    var countEl = document.getElementById('cart-drawer-count');
    var badge = document.getElementById('cart-count');
    if (!empty || !full) return;

    if (badge) {
      if (cart.item_count > 0) { badge.hidden = false; badge.textContent = cart.item_count; }
      else badge.hidden = true;
    }
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';

    if (cart.item_count === 0) {
      empty.hidden = false;
      full.hidden = true;
      return;
    }
    empty.hidden = true;
    full.hidden = false;

    var ul = document.getElementById('cart-lines');
    ul.innerHTML = cart.items.map(function (item) {
      return '' +
        '<li class="cart-line">' +
        '<a href="' + item.url + '" class="thumb"><img src="' + (item.image || '') + '&width=160" alt="" loading="lazy"></a>' +
        '<div class="body">' +
        '<a href="' + item.url + '" class="name">' + item.product_title + '</a>' +
        '<div class="row">' +
        '<div class="qty-stepper" data-line-key="' + item.key + '">' +
        '<button type="button" data-qty="-1" aria-label="Una menos"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" width="14" height="14"><path d="M5 12h14"/></svg></button>' +
        '<span class="cifra">' + item.quantity + '</span>' +
        '<button type="button" data-qty="1" aria-label="Una más"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" width="14" height="14"><path d="M12 5v14M5 12h14"/></svg></button>' +
        '</div>' +
        '<div>' +
        '<p class="price cifra">' + euro(item.line_price) + '</p>' +
        '<button type="button" class="remove" data-line-remove="' + item.key + '">Quitar</button>' +
        '</div>' +
        '</div></div></li>';
    }).join('');

    var subtotalCajon = cart.items_subtotal_price;
    var shipping = shippingFor(subtotalCajon, cart.total_weight);
    document.getElementById('cart-subtotal').textContent = euro(subtotalCajon);
    document.getElementById('cart-shipping').textContent = euro(shipping);
    document.getElementById('cart-total').textContent = euro(subtotalCajon + shipping);
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }
  function refreshCart() {
    return fetchCart().then(function (cart) {
      renderDrawer(cart);
      renderCartPage(cart);
      return cart;
    });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    }).then(function (r) { return r.json(); }).then(function () { return refreshCart(); });
  }
  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (r) { return r.json(); }).then(refreshCart);
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-add-to-cart], #pdp-add-cart');
    if (addBtn) {
      var vid = addBtn.getAttribute('data-variant-id');
      if (!vid) return;
      var etiqueta = addBtn.querySelector('span') || addBtn;
      var original = etiqueta.textContent;
      addBtn.classList.add('cargando');
      addToCart(vid, 1).then(function () {
        addBtn.classList.remove('cargando');
        addBtn.classList.add('hecho');
        etiqueta.textContent = 'Añadido';
        openDrawer();
        setTimeout(function () {
          etiqueta.textContent = original;
          addBtn.classList.remove('hecho');
        }, 1600);
      });
      return;
    }

    var buyNow = e.target.closest('#pdp-buy-now');
    if (buyNow) {
      var vid2 = buyNow.getAttribute('data-variant-id');
      addToCart(vid2, 1).then(function () { window.location.href = '/checkout'; });
      return;
    }

    if (e.target.closest('#cart-open-btn')) { openDrawer(); return; }
    if (e.target.closest('#cart-close-btn') || e.target.closest('#cart-overlay') || e.target.closest('#cart-continue-btn')) { closeDrawer(); return; }

    var qtyBtn = e.target.closest('[data-qty]');
    if (qtyBtn) {
      var stepper = qtyBtn.closest('[data-line-key]');
      var key = stepper.getAttribute('data-line-key');
      var delta = parseInt(qtyBtn.getAttribute('data-qty'), 10);
      var current = parseInt(stepper.querySelector('span').textContent, 10);
      changeLine(key, Math.max(0, current + delta));
      return;
    }
    var removeBtn = e.target.closest('[data-line-remove]');
    if (removeBtn) { changeLine(removeBtn.getAttribute('data-line-remove'), 0); return; }

    if (e.target.closest('#cart-page-clear')) {
      fetch('/cart/clear.js', { method: 'POST' }).then(refreshCart);
      return;
    }
    if (e.target.closest('#cart-page-checkout')) { window.location.href = '/checkout'; return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- Cart page (JS-rendered desde /cart.js) ---------- */
  function renderCartPage(cart) {
    var root = document.getElementById('cart-page-root');
    if (!root) return;
    var empty = document.getElementById('cart-page-empty');
    var full = document.getElementById('cart-page-full');

    if (cart.item_count === 0) { empty.hidden = false; full.hidden = true; return; }
    empty.hidden = true; full.hidden = false;

    var PEDIDO_MINIMO_CENTS = 499;
    var ul = document.getElementById('cart-page-lines');
    ul.innerHTML = cart.items.map(function (item) {
      return '' +
        '<li class="cart-page-line">' +
        '<a href="' + item.url + '" class="thumb"><img src="' + (item.image || '') + '&width=200" alt="" loading="lazy"></a>' +
        '<div class="body">' +
        '<a href="' + item.url + '" class="name">' + item.product_title + '</a>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="model">' + item.variant_title + '</p>' : '') +
        '<p class="unit cifra">' + euro(item.price) + ' / ud</p>' +
        '<div class="row">' +
        '<div class="qty-stepper" data-line-key="' + item.key + '">' +
        '<button type="button" data-qty="-1" aria-label="Una menos">−</button>' +
        '<span class="cifra">' + item.quantity + '</span>' +
        '<button type="button" data-qty="1" aria-label="Una más">+</button>' +
        '</div>' +
        '<button type="button" class="remove" data-line-remove="' + item.key + '" style="background:none;border:0;color:var(--tinta-suave);text-decoration:underline;font-size:12px">Quitar</button>' +
        '</div></div>' +
        '<p class="line-total cifra">' + euro(item.line_price) + '</p>' +
        '</li>';
    }).join('');

    var subtotal = cart.items_subtotal_price;
    var shipping = shippingFor(subtotal, cart.total_weight);
    var bajoMinimo = subtotal > 0 && subtotal < PEDIDO_MINIMO_CENTS;

    document.getElementById('cart-page-subtotal').textContent = euro(subtotal);
    document.getElementById('cart-page-shipping').textContent = euro(shipping);
    document.getElementById('cart-page-total').textContent = euro(subtotal + shipping);

    var note = document.getElementById('cart-page-shipping-note');
    var checkoutBtn = document.getElementById('cart-page-checkout');
    if (bajoMinimo) {
      note.textContent = 'Pedido mínimo ' + euro(PEDIDO_MINIMO_CENTS) + '. Añade ' + euro(PEDIDO_MINIMO_CENTS - subtotal) + ' más.';
      note.classList.add('warn');
      checkoutBtn.textContent = 'Mínimo ' + euro(PEDIDO_MINIMO_CENTS);
      checkoutBtn.disabled = true;
    } else {
      note.classList.remove('warn');
      note.textContent = subtotal >= DTO_DESDE_CENTS
        ? 'Usa tu código CARTUCHOYA10 en el paso de pago: 10 % de descuento.'
        : ('Te faltan ' + euro(DTO_DESDE_CENTS - subtotal) + ' para poder usar tu código del 10 %.');
      checkoutBtn.textContent = 'Pagar con tarjeta';
      checkoutBtn.disabled = false;
    }
  }

  /* ---------- Discount popup ---------- */
  function initPopup() {
    var overlayEl = document.getElementById('discount-popup-overlay');
    if (!overlayEl) return;
    var closeBtn = document.getElementById('discount-popup-close');
    var KEY = 'cartuchoya_popup_boletin';
    var WEEK = 7 * 24 * 60 * 60 * 1000;

    function show() { overlayEl.classList.add('open'); }
    function hide() {
      overlayEl.classList.remove('open');
      try { window.localStorage.setItem(KEY, new Date().toISOString()); } catch (e) {}
    }
    if (closeBtn) closeBtn.addEventListener('click', hide);
    overlayEl.addEventListener('click', function (e) { if (e.target === overlayEl) hide(); });

    if (qs('descuento') === '1') { show(); return; }

    var last = null;
    try { last = window.localStorage.getItem(KEY); } catch (e) {}
    if (last) {
      var since = Date.now() - new Date(last).getTime();
      if (!isNaN(since) && since < WEEK) return;
    }
    setTimeout(function () {
      show();
      try { window.localStorage.setItem(KEY, new Date().toISOString()); } catch (e) {}
    }, 9000);
  }

  /* ---------- Social proof (PDP) ---------- */
  /* ---------- Prueba social: quién compró esta semana ---------- */
  function initSocialProof() {
    var el = document.getElementById('social-proof');
    if (!el) return;

    // Avatares ilustrados (no son fotos de personas reales).
    function avatar(fondo, pelo, largo) {
      var melena = largo
        ? "<path d='M8 22c0-9 5-14 12-14s12 5 12 14v6h-4V19c0-5-3-8-8-8s-8 3-8 8v9H8z' fill='" + pelo + "'/>"
        : "<path d='M9 17c0-7 4.5-10 11-10s11 3 11 10c0-3-3.5-4.5-11-4.5S9 14 9 17z' fill='" + pelo + "'/>";
      var svg =
        "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'>" +
        "<rect width='40' height='40' fill='" + fondo + "'/>" +
        "<path d='M5 40c0-8.5 6.7-13 15-13s15 4.5 15 13z' fill='#fff'/>" +
        "<circle cx='20' cy='17' r='7.5' fill='#fff'/>" + melena + "</svg>";
      return 'data:image/svg+xml,' + encodeURIComponent(svg);
    }

    var CARAS = [
      avatar('#00a8e8', '#2b2118', true),
      avatar('#ec008c', '#1d1b19', false),
      avatar('#ffd400', '#4a2f1b', true),
      avatar('#0e0e0e', '#6b4b2a', false),
      avatar('#0a6cdc', '#3a2a20', false),
      avatar('#1d7a4c', '#241c16', true),
      avatar('#c0392b', '#2f2119', false),
      avatar('#5a5a5a', '#3d2b1f', true),
    ];

    var GRUPOS = [
      { a: 'Andrea', b: 'Lucía', mas: 16, ca: 0, cb: 2 },
      { a: 'María', b: 'Pablo', mas: 12, ca: 5, cb: 3 },
      { a: 'Sofía', b: 'Carlos', mas: 9, ca: 7, cb: 4 },
      { a: 'Laura', b: 'Javier', mas: 14, ca: 1, cb: 6 },
    ];

    function render(i) {
      var g = GRUPOS[i];
      el.innerHTML =
        '<span class="avatars">' +
        '<img src="' + CARAS[g.ca] + '" alt="" width="26" height="26">' +
        '<img src="' + CARAS[g.cb] + '" alt="" width="26" height="26">' +
        '<span class="more">+' + g.mas + '</span></span>' +
        '<span><strong>' + g.a + '</strong> y <strong>' + g.b + '</strong> y ' + g.mas + ' más compraron esta semana</span>';
    }

    var dias = Math.floor(Date.now() / 86400000);
    var idx = dias % GRUPOS.length;
    render(idx);
    setInterval(function () { idx = (idx + 1) % GRUPOS.length; render(idx); }, 5000);
  }

  function initGallery() {
    var thumbs = document.querySelectorAll('[data-thumb]');
    var main = document.getElementById('pdp-main-img');
    if (!thumbs.length || !main) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        /* El srcset que pone Shopify gana sobre src: hay que quitarlo o la principal no cambia. */
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = t.getAttribute('data-full');
      });
    });
  }

  /* ---------- PDP variant picker (color) ---------- */
  function initVariantPicker() {
    var picker = document.querySelector('[data-variant-picker]');
    if (!picker) return;
    var variants;
    try { variants = JSON.parse(picker.getAttribute('data-product-json')); } catch (e) { return; }

    var buyBtn = document.getElementById('pdp-buy-now');
    var addBtn = document.getElementById('pdp-add-cart');

    var udsPorVariante = {};
    var udsEl = document.querySelector('[data-pdp-uds]');
    try { udsPorVariante = JSON.parse(document.getElementById('pdp-uds').textContent); } catch (e) {}
    var detallePorVariante = {};
    try { detallePorVariante = JSON.parse(document.getElementById('pdp-detalles').textContent); } catch (e) {}

    function applySelection() {
      var selected = [];
      picker.querySelectorAll('.pdp-pack.active').forEach(function (btn) {
        selected[parseInt(btn.getAttribute('data-option-index'), 10)] = btn.getAttribute('data-value');
      });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] === undefined || opt === selected[i]; });
      });
      if (!match) return;
      if (buyBtn) buyBtn.setAttribute('data-variant-id', match.id);
      if (addBtn) addBtn.setAttribute('data-variant-id', match.id);
      // Sin existencias de esta combinación: no se puede comprar
      var hay = match.available !== false;
      [buyBtn, addBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !hay;
        b.classList.toggle('btn-disabled', !hay);
        if (!b.getAttribute('data-texto')) b.setAttribute('data-texto', b.textContent.trim());
        b.textContent = hay ? b.getAttribute('data-texto') : 'Agotado';
      });
      var priceEl = document.querySelector('[data-pdp-precio]');
      if (priceEl && match.price) priceEl.textContent = euro(match.price);
      var antes = match.compare_at_price;
      var hayDto = antes && antes > match.price;
      var antesEl = document.querySelector('[data-pdp-antes]');
      if (antesEl) {
        antesEl.textContent = hayDto ? euro(antes) : '';
        antesEl.closest('.pdp-pvp').hidden = !hayDto;
      }
      var dtoEl = document.querySelector('[data-pdp-dto]');
      if (dtoEl) {
        dtoEl.textContent = hayDto ? '-' + Math.round((antes - match.price) / antes * 100) + ' %' : '';
        dtoEl.hidden = !hayDto;
      }
      if (udsEl) {
        var uds = udsPorVariante[match.id];
        udsEl.textContent = uds ? 'Llevas ' + uds + (uds === 1 ? ' unidad' : ' unidades') : '';
      }
      var vEl = document.querySelector('[data-pdp-variante]');
      if (vEl) vEl.textContent = match.title && match.title !== 'Default Title' ? ' \u2014 ' + match.title : '';
      var detEl = document.querySelector('[data-pdp-detalle]');
      if (detEl) {
        var txt = detallePorVariante[match.id] || '';
        detEl.textContent = txt;
        detEl.hidden = !txt;
      }
      /* Miniaturas: las que pertenecen a una variante solo se ven con esa variante;
         las que no pertenecen a ninguna (infografías) se ven siempre. */
      var thumbs = document.querySelectorAll('[data-thumb]');
      var deEsta = null;
      thumbs.forEach(function (t) {
        var lista = (t.getAttribute('data-variantes') || '').split(',').filter(Boolean);
        var esDeOtra = lista.length > 0 && lista.indexOf(String(match.id)) === -1;
        t.hidden = esDeOtra;
        if (lista.indexOf(String(match.id)) !== -1) deEsta = t;
      });
      var foto = match.featured_image && match.featured_image.src;
      var principal = document.getElementById('pdp-main-img');
      if (foto && principal) {
        principal.removeAttribute('srcset');
        principal.removeAttribute('sizes');
        principal.src = foto.split('?')[0] + '?width=900';
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        if (deEsta) deEsta.classList.add('active');
      }
    }

    picker.querySelectorAll('.pdp-pack').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-option-index');
        picker.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (sib) { sib.classList.remove('active'); });
        btn.classList.add('active');
        applySelection();
      });
    });
  }

  /* ---------- Productos: buscador/filtro/orden (client-side, como Next.js) ---------- */
  /* ---------- Productos: filtro/orden sobre las tarjetas ya pintadas ---------- */
  function initProductList() {
    var grid = document.getElementById('plp-grid');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-product-card]'));
    var titleEl = document.getElementById('plp-title');
    var countEl = document.getElementById('plp-count');
    var emptyEl = document.getElementById('plp-empty');
    var emptyText = document.getElementById('plp-empty-text');
    var searchInput = document.getElementById('plp-search');
    var filtersWrap = document.getElementById('plp-filters');
    var hayToggle = document.getElementById('plp-hay-toggle');

    cards.forEach(function (c) {
      c._titulo = c.getAttribute('data-title') || '';
      c._tipo = c.getAttribute('data-type') || '';
      c._precio = parseInt(c.getAttribute('data-price'), 10) || 0;
      c._hay = c.getAttribute('data-available') === 'true';
      c._busca = normalize(c._titulo + ' ' + c._tipo + ' ' + (c.getAttribute('data-busca') || ''));
    });

    var state = {
      q: qs('q') || '',
      cat: qs('cat') || '',
      orden: qs('orden') || 'precio-asc',
      hay: qs('hay') === '1',
    };
    searchInput.value = state.q;

    function syncUrl() {
      var p = new URLSearchParams();
      if (state.q) p.set('q', state.q);
      if (state.cat) p.set('cat', state.cat);
      if (state.orden !== 'precio-asc') p.set('orden', state.orden);
      if (state.hay) p.set('hay', '1');
      var s = p.toString();
      history.replaceState(null, '', s ? '/pages/productos?' + s : '/pages/productos');
    }

    function render() {
      var needle = normalize(state.q);
      var visibles = cards.filter(function (c) {
        if (state.cat && c._tipo !== state.cat) return false;
        if (state.hay && !c._hay) return false;
        if (!state.q) return true;
        return c._busca.indexOf(needle) !== -1;
      });

      visibles.sort(function (a, b) {
        if (state.orden === 'nombre') return a._titulo.localeCompare(b._titulo, 'es');
        if (state.orden === 'precio-desc') return b._precio - a._precio;
        return a._precio - b._precio;
      });

      cards.forEach(function (c) { c.hidden = true; });
      visibles.forEach(function (c) { c.hidden = false; grid.appendChild(c); });

      titleEl.textContent = state.cat || 'Todos los productos';
      countEl.textContent = visibles.length + (visibles.length === 1 ? ' artículo' : ' artículos');

      filtersWrap.querySelectorAll('[data-cat]').forEach(function (b) {
        b.classList.toggle('active', b.getAttribute('data-cat') === state.cat);
      });
      filtersWrap.querySelectorAll('[data-orden]').forEach(function (b) {
        b.classList.toggle('active', b.getAttribute('data-orden') === state.orden);
      });
      hayToggle.classList.toggle('active', state.hay);
      hayToggle.classList.toggle('avail', state.hay);

      emptyEl.hidden = visibles.length > 0;
      grid.hidden = visibles.length === 0;
      if (visibles.length === 0) {
        emptyText.textContent = 'No hay nada' + (state.q ? ' para "' + state.q + '"' : '') + (state.cat ? ' en ' + state.cat : '') + '.';
      }
      syncUrl();
    }

    var t;
    searchInput.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () { state.q = searchInput.value.trim(); render(); }, 150);
    });
    filtersWrap.addEventListener('click', function (e) {
      var catBtn = e.target.closest('[data-cat]');
      if (catBtn) { state.cat = catBtn.getAttribute('data-cat'); render(); return; }
      var ordBtn = e.target.closest('[data-orden]');
      if (ordBtn) { state.orden = ordBtn.getAttribute('data-orden'); render(); return; }
      if (e.target.closest('#plp-hay-toggle')) { state.hay = !state.hay; render(); return; }
    });

    render();
  }

  /* ---------- Tarjetas de marca: inclinación 3D al pasar el ratón ---------- */
  function initTilt() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('[data-tilt] > a').forEach(function (caja) {
      caja.addEventListener('mousemove', function (e) {
        var r = caja.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        caja.style.transform = 'rotateX(' + (-y * 9) + 'deg) rotateY(' + (x * 11) + 'deg) translateY(-4px)';
      });
      caja.addEventListener('mouseleave', function () { caja.style.transform = ''; });
    });
  }

  /* ---------- Tarjeta: carrusel de fotos y selector de pack ---------- */
  function initCards() {
    document.querySelectorAll('.pcard-fotos').forEach(function (caja) {
      var fotos = caja.querySelectorAll('.pcard-foto');
      if (fotos.length < 2) return;
      var puntos = caja.parentElement.querySelectorAll('.pcard-puntos span');
      var i = 0, timer = null;
      function ir(n) {
        fotos[i].style.opacity = '0';
        if (puntos[i]) puntos[i].classList.remove('on');
        i = n;
        fotos[i].style.opacity = '1';
        if (puntos[i]) puntos[i].classList.add('on');
      }
      var card = caja.closest('.pcard');
      card.addEventListener('mouseenter', function () {
        if (timer) return;
        timer = setInterval(function () { ir((i + 1) % fotos.length); }, 1100);
      });
      card.addEventListener('mouseleave', function () {
        clearInterval(timer); timer = null; ir(0);
      });
    });

  }

  /* El mp4 del hero pesa; no compite con CSS ni fuente en la primera pintada. */
  /* ---------- Opiniones: visor de fotos y formulario ---------- */
  function initOpiniones() {
    var modal = document.getElementById('op-modal');
    var visor = document.getElementById('op-visor');

    function abrir(el) { if (el) { el.hidden = false; document.body.style.overflow = 'hidden'; } }
    function cerrar(el) { if (el) { el.hidden = true; document.body.style.overflow = ''; } }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-op-abrir]')) { abrir(modal); return; }
      if (e.target.closest('[data-op-cerrar]') || e.target === modal) { cerrar(modal); return; }

      var foto = e.target.closest('[data-op-foto]');
      if (foto && visor) {
        document.getElementById('op-visor-img').src = foto.getAttribute('data-op-foto');
        document.getElementById('op-visor-pie').textContent = 'Foto de ' + (foto.getAttribute('data-op-quien') || 'un cliente');
        abrir(visor);
        return;
      }
      if (e.target.closest('[data-op-cerrar-visor]') || e.target === visor) { cerrar(visor); return; }

      var estrella = e.target.closest('[data-op-picker] button');
      if (estrella) {
        var valor = parseInt(estrella.getAttribute('data-valor'), 10);
        var campo = document.getElementById('op-punt');
        if (campo) campo.value = String(valor);
        estrella.parentElement.querySelectorAll('button').forEach(function (b, i) {
          b.classList.toggle('on', i < valor);
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { cerrar(modal); cerrar(visor); }
    });

    /* arranca con 5 estrellas marcadas */
    var picker = document.querySelector('[data-op-picker]');
    if (picker) picker.querySelectorAll('button').forEach(function (b) { b.classList.add('on'); });

    /* tras enviar, Shopify vuelve con ?contact_posted=true: lo pasamos a nuestro aviso */
    if (/contact_posted=true/.test(window.location.search) && !/opinion=1/.test(window.location.search)) {
      var u = new URL(window.location.href);
      u.searchParams.delete('contact_posted');
      u.searchParams.set('opinion', '1');
      u.hash = 'opiniones';
      window.location.replace(u.toString());
    }
  }

  function initHeroVideo() {
    var v = document.querySelector('[data-hero-video]');
    if (!v) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(max-width: 767px)').matches) return;
    var fuente = v.querySelector('source');
    function arranca() {
      if (v.dataset.cargado) return;
      v.dataset.cargado = '1';
      fuente.src = fuente.getAttribute('data-src');
      v.load();
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    if ('requestIdleCallback' in window) requestIdleCallback(arranca, { timeout: 2500 });
    else setTimeout(arranca, 1200);
  }

  document.addEventListener('DOMContentLoaded', function () {
    startCountdowns();
    initPopup();
    initSocialProof();
    initGallery();
    initVariantPicker();
    initProductList();
    initCards();
    initOpiniones();
    initTilt();
    initHeroVideo();
    refreshCart();
  });
})();
